@if (store) {
  <hawk-record-navigation
    class="app-page"
    [breadcrumbLinkList]="[{ description: 'Filialen', link: '/a/filiale' }]"
    [root]="'store'"
    [leafDescription]="store.name"
  >
    <div slot="toolbar" class="flex flex-row gap-2 items-center">
      <div
        [class.bm-tooltip]="!storeIsDeletable"
        [attr.data-tip]="'Filialen können nur gelöscht werden, wenn keine Abhängigkeiten zu Tickets vorhanden sind'"
        class="bm-tooltip-left"
      >
        <button class="bm-btn bm-btn-error" [disabled]="!storeIsDeletable" (click)="deleteStore()">
          <fa-icon [icon]="faTrash" />
          Löschen
        </button>
      </div>
    </div>
    <div class="page-content px-4 pb-2 overflow-auto">
      <div class="page-sheet max-w-7xl mx-auto grid grid-cols-3 gap-4">
        <div class="col-span-2 grid grid-cols-2 gap-4">
          <ng-container [ngTemplateOutlet]="tplStammdaten" />
          <ng-container [ngTemplateOutlet]="tplOpening" />
          <ng-container [ngTemplateOutlet]="tplAusstattung" />
          <ng-container [ngTemplateOutlet]="tplAdresse" />
        </div>
        <ng-container [ngTemplateOutlet]="tplKarte" />
        <div class="col-span-3">
          <ng-container [ngTemplateOutlet]="tplTickets" />
        </div>
      </div>
    </div>
  </hawk-record-navigation>
}

<ng-template #tplStammdaten>
  <section class="bm-card bm-card-sm bm-card-body bm-card-border border-base-300">
    <h3 class="bm-card-title bm-card-title-top bg-base-100">Stammdaten</h3>
    <dl class="bm-dl">
      <dt (click)="editNr = !editNr">
        Nr
        <button class="bm-btn bm-btn-sm bm-btn-square bm-btn-ghost">
          <fa-icon [icon]="['far', 'edit']" />
        </button>
      </dt>
      <dd>
        @if (!editNr) {
          {{ store.nr }}
        } @else {
          <hawk-shared-edit-input
            [textValue]="store.nr"
            (saveClicked)="saveNr($any($event))"
            (cancelClicked)="editNr = false"
          />
        }
      </dd>
      <dt (click)="editName = !editName">
        Name
        <button class="bm-btn bm-btn-sm bm-btn-square bm-btn-ghost">
          <fa-icon [icon]="['far', 'edit']" />
        </button>
      </dt>
      <dd>
        @if (!editName) {
          {{ store.name }}
        } @else {
          <hawk-shared-edit-input
            [textValue]="store.name"
            (saveClicked)="saveName($any($event))"
            (cancelClicked)="editName = false"
          />
        }
      </dd>
      <dt (click)="editCustomer = !editCustomer">
        Kunden
        <button class="bm-btn bm-btn-sm bm-btn-square bm-btn-ghost">
          <fa-icon [icon]="['far', 'edit']" />
        </button>
      </dt>
      <dd>
        @if (!editCustomer) {
          @for (customer of storeCustomers; track $index) {
            <a class="mr6" [routerLink]="'/kunde/' + customer.id">
              {{ customer.name }}
            </a>
          }
        } @else {
          <hawk-shared-edit-input
            [modus]="'multiselect'"
            [multiSelectValue]="selectedStoreCustomerIds"
            [selectOptions]="customers"
            (saveClicked)="saveCustomers($any($event))"
            (cancelClicked)="editCustomer = false"
          />
        }
      </dd>
      <dt (click)="editMail = !editMail">
        E-Mail
        <button class="bm-btn bm-btn-sm bm-btn-square bm-btn-ghost">
          <fa-icon [icon]="['far', 'edit']" />
        </button>
      </dt>
      <dd>
        @if (!editMail) {
          <a [href]="'mailto:' + store.email">{{ store.email }}</a>
        } @else {
          <hawk-shared-edit-input
            [textValue]="store.email"
            (saveClicked)="saveMail($any($event))"
            (cancelClicked)="editMail = false"
          />
        }
      </dd>
      <dt (click)="editPhone1 = !editPhone1">
        Telefon 1
        <button class="bm-btn bm-btn-sm bm-btn-square bm-btn-ghost">
          <fa-icon [icon]="['far', 'edit']" />
        </button>
      </dt>
      <dd>
        @if (!editPhone1) {
          <a [href]="'phone:' + store.phone1">{{ store.phone1 }}</a>
        } @else {
          <hawk-shared-edit-input
            [textValue]="store.phone1"
            (saveClicked)="savePhone1($any($event))"
            (cancelClicked)="editPhone1 = false"
          />
        }
      </dd>
      <dt (click)="editPhone2 = !editPhone2">
        Telefon 2
        <button class="bm-btn bm-btn-sm bm-btn-square bm-btn-ghost">
          <fa-icon [icon]="['far', 'edit']" />
        </button>
      </dt>
      <dd>
        @if (!editPhone2) {
          <a [href]="'phone:' + store.phone2">{{ store.phone2 }}</a>
        } @else {
          <hawk-shared-edit-input
            [textValue]="store.phone2"
            (saveClicked)="savePhone2($any($event))"
            (cancelClicked)="editPhone2 = false"
          />
        }
      </dd>
      <dt (click)="editComment = !editComment">
        Kommentar
        <button class="bm-btn bm-btn-sm bm-btn-square bm-btn-ghost">
          <fa-icon [icon]="['far', 'edit']" />
        </button>
      </dt>
      <dd>
        @if (!editComment) {
          {{ store.comment }}
        } @else {
          <hawk-shared-edit-input
            [textValue]="store.comment"
            (saveClicked)="saveComment($any($event))"
            (cancelClicked)="editComment = false"
          />
        }
      </dd>
    </dl>
  </section>
</ng-template>
<ng-template #tplOpening>
  <section class="bm-card bm-card-sm bm-card-body bm-card-border border-base-300">
    <h3 class="bm-card-title bm-card-title-top bg-base-100">
      Öffnungszeiten
      <button class="bm-btn bm-btn-sm bm-btn-square bm-btn-ghost" (click)="openOpeningModal()">
        <fa-icon [icon]="['far', 'plus']" />
      </button>
    </h3>
    <dl class="bm-dl">
      <dt>Montag</dt>
      <dd>
        <div class="flex flex-row flex-wrap gap-1">
          @for (opening of mondayOpenings; track opening) {
            <div class="flex items-center gap-1">
              {{ opening.open }} - {{ opening.close }}
              <button class="bm-btn bm-btn-xs bm-btn-square bm-btn-ghost" (click)="deleteOpening(opening)">
                <fa-icon [icon]="faTrash" />
              </button>
            </div>
          }
        </div>
      </dd>
      <dt>Dienstag</dt>
      <dd>
        <div class="flex flex-row flex-wrap gap-1">
          @for (opening of tuesdayOpenings; track opening) {
            <div class="flex items-center gap-1">
              {{ opening.open }} - {{ opening.close }}
              <button class="bm-btn bm-btn-xs bm-btn-square bm-btn-ghost" (click)="deleteOpening(opening)">
                <fa-icon [icon]="faTrash" />
              </button>
            </div>
          }
        </div>
      </dd>
      <dt>Mittwoch</dt>
      <dd>
        <div class="flex flex-row flex-wrap gap-1">
          @for (opening of wednesdayOpenings; track opening) {
            <div class="flex items-center gap-1">
              {{ opening.open }} - {{ opening.close }}
              <button class="bm-btn bm-btn-xs bm-btn-square bm-btn-ghost" (click)="deleteOpening(opening)">
                <fa-icon [icon]="faTrash" />
              </button>
            </div>
          }
        </div>
      </dd>
      <dt>Donnerstag</dt>
      <dd>
        <div class="flex flex-row flex-wrap gap-1">
          @for (opening of thursdayOpenings; track opening) {
            <div class="flex items-center gap-1">
              {{ opening.open }} - {{ opening.close }}
              <button class="bm-btn bm-btn-xs bm-btn-square bm-btn-ghost" (click)="deleteOpening(opening)">
                <fa-icon [icon]="faTrash" />
              </button>
            </div>
          }
        </div>
      </dd>
      <dt>Freitag</dt>
      <dd>
        <div class="flex flex-row flex-wrap gap-1">
          @for (opening of fridayOpenings; track opening) {
            <div class="flex items-center gap-1">
              {{ opening.open }} - {{ opening.close }}
              <button class="bm-btn bm-btn-xs bm-btn-square bm-btn-ghost" (click)="deleteOpening(opening)">
                <fa-icon [icon]="faTrash" />
              </button>
            </div>
          }
        </div>
      </dd>
      <dt>Samstag</dt>
      <dd>
        <div class="flex flex-row flex-wrap gap-1">
          @for (opening of saturdayOpenings; track opening) {
            <div class="flex items-center gap-1">
              {{ opening.open }} - {{ opening.close }}
              <button class="bm-btn bm-btn-xs bm-btn-square bm-btn-ghost" (click)="deleteOpening(opening)">
                <fa-icon [icon]="faTrash" />
              </button>
            </div>
          }
        </div>
      </dd>
      <dt>Sonntag</dt>
      <dd>
        <div class="flex flex-row flex-wrap gap-1">
          @for (opening of sundayOpenings; track opening) {
            <div class="flex items-center gap-1">
              {{ opening.open }} - {{ opening.close }}
              <button class="bm-btn bm-btn-xs bm-btn-square bm-btn-ghost" (click)="deleteOpening(opening)">
                <fa-icon [icon]="faTrash" />
              </button>
            </div>
          }
        </div>
      </dd>
    </dl>
  </section>
</ng-template>
<ng-template #tplAusstattung>
  <section class="bm-card bm-card-sm bm-card-body bm-card-border border-base-300">
    <h3 class="bm-card-title bm-card-title-top bg-base-100">Ausstattung</h3>
    <dl class="bm-dl">
      <dt (click)="editRegister = !editRegister">
        Anzahl Kassen
        <button class="bm-btn bm-btn-sm bm-btn-square bm-btn-ghost">
          <fa-icon [icon]="['far', 'edit']" />
        </button>
      </dt>
      <dd>
        @if (!editRegister) {
          {{ store.register }}
        } @else {
          <hawk-shared-edit-input
            [modus]="'number'"
            [numberValue]="store.register"
            (saveClicked)="saveRegister($any($event))"
            (cancelClicked)="editRegister = false"
          />
        }
      </dd>
      <dt (click)="editIP = !editIP">
        IP
        <button class="bm-btn bm-btn-sm bm-btn-square bm-btn-ghost">
          <fa-icon [icon]="['far', 'edit']" />
        </button>
      </dt>
      <dd>
        @if (!editIP) {
          {{ store.ip }}
        } @else {
          <hawk-shared-edit-input
            [textValue]="store.ip"
            (saveClicked)="saveIP($any($event))"
            (cancelClicked)="editIP = false"
          />
        }
      </dd>
    </dl>
  </section>
</ng-template>
<ng-template #tplAdresse>
  <section class="bm-card bm-card-sm bm-card-body bm-card-border border-base-300">
    <h3 class="bm-card-title bm-card-title-top bg-base-100">
      Adresse
      <button class="bm-btn bm-btn-sm bm-btn-square bm-btn-ghost" (click)="showModal = 'address'">
        <fa-icon [icon]="['far', 'edit']" />
      </button>
    </h3>
    <a
      class="bm-btn bm-btn-xs bm-btn-ghost absolute -top-[0.75em] right-1 bg-base-100"
      [href]="'https://maps.google.de?q=' + [store.address_street, store.address_zip, store.address_city].join(',')"
      target="_blank"
    >
      <fa-icon [icon]="faExternalLinkAlt" /> Google Maps
    </a>
    <dl class="bm-dl">
      <dt>Firma</dt>
      <dd>{{ store.address_company }}</dd>
      <dt>Name</dt>
      <dd>{{ (store.address_firstname || "") + " " + (store.address_lastname || "") }}</dd>
      <dt>Straße</dt>
      <dd>{{ store.address_street }}</dd>
      <dt>PLZ und Ort</dt>
      <dd>{{ store.address_zip }} {{ store.address_city }}</dd>
      <dt>Land / BL</dt>
      <dd>
        {{ (store.address_country || "").toUpperCase() }}
        @if (store.address_state) {
          / {{ formatState(store.address_state) }}
        }
      </dd>
    </dl>
  </section>
</ng-template>
<ng-template #tplKarte>
  <section class="bm-card bm-card-sm bm-card-body bm-card-border border-base-300 h-full">
    <h3 class="bm-card-title bm-card-title-top bg-base-100">Karte</h3>
    @if (store.address_latitude && store.address_longitude) {
      <mgl-map
        [style]="'mapbox://styles/mapbox/streets-v9'"
        [zoom]="[5]"
        [center]="[store.address_longitude, store.address_latitude]"
        class="flex-1 min-h-0"
      >
        <mgl-marker [lngLat]="[store.address_longitude, store.address_latitude]">
          <div
            class="marker"
            [style.borderColor]="'black'"
            [style.backgroundColor]="'#af0000'"
            title="{{ store.name }}"
          ></div>
        </mgl-marker>
      </mgl-map>
    }
  </section>
</ng-template>
<ng-template #tplTickets>
  <section class="bm-card bm-card-sm bm-card-body bm-card-border border-base-300">
    <h3 class="bm-card-title bm-card-title-top bg-base-100">Tickets</h3>
    <div class="flex justify-end mb-2">
      <input type="text" class="bm-input w-52" placeholder="Schnellfilter..." (input)="quickSearchChanged($event)" />
    </div>
    <ag-grid-angular
      class="ag-theme-quartz"
      style="height: 480px; width: 100%"
      [rowData]="tickets"
      [theme]="hawkTheme"
      [defaultColDef]="defaultColDef"
      [columnDefs]="colDefs"
      [rowClassRules]="rowClassRules"
      [pagination]="true"
      [rowSelection]="rowSelection"
      [paginationPageSize]="16"
      [localeText]="locale"
      [sideBar]="sideBarOptions"
      [paginationPageSizeSelector]="[16, 32, 64, 128]"
      (gridReady)="onGridReady($event)"
    />
  </section>
</ng-template>

@if (showModal === "address") {
  <dialog class="bm-modal" open>
    <div class="bm-modal-box">
      <hawk-shared-edit-address
        [city]="store.address_city"
        [company]="store.address_company"
        [country]="store.address_country"
        [lat]="store.address_latitude"
        [lng]="store.address_longitude"
        [state]="store.address_state"
        [street]="store.address_street"
        [zip]="store.address_zip"
        [firstname]="store.address_firstname"
        [lastname]="store.address_lastname"
        [editName]="true"
        (onSubmitEvent)="saveAddress($event)"
        (onAbortEvent)="showModal = null"
      />
    </div>
  </dialog>
}
@if (showModal === "openings") {
  <dialog class="bm-modal" open>
    <div class="bm-modal-box">
      <h3 class="text-lg font-bold">Öffnungszeiten hinzufügen</h3>
      <div class="flex flex-row gap-4 mt-4">
        <label>
          <input type="checkbox" class="bm-checkbox" [(ngModel)]="setMonday" />
          Mo
        </label>
        <label>
          <input type="checkbox" class="bm-checkbox" [(ngModel)]="setTuesday" />
          Di
        </label>
        <label>
          <input type="checkbox" class="bm-checkbox" [(ngModel)]="setWednesday" />
          Mi
        </label>
        <label>
          <input type="checkbox" class="bm-checkbox" [(ngModel)]="setThursday" />
          Do
        </label>
        <label>
          <input type="checkbox" class="bm-checkbox" [(ngModel)]="setFriday" />
          Fr
        </label>
        <label>
          <input type="checkbox" class="bm-checkbox" [(ngModel)]="setSaturday" />
          Sa
        </label>
        <label>
          <input type="checkbox" class="bm-checkbox" [(ngModel)]="setSunday" />
          So
        </label>
      </div>
      <div class="flex flex-row mt-4 gap-4">
        <div class="bm-input">
          <label>Von</label>
          <input type="time" class="w-full" [(ngModel)]="timeFrom" />
        </div>
        <div class="bm-input">
          <label>Bis</label>
          <input type="time" class="w-full" [(ngModel)]="timeUntil" />
        </div>
      </div>
      <div class="bm-modal-action">
        <button class="bm-btn" (click)="showModal = null">Abbrechen</button>
        <button class="bm-btn bm-btn-primary" (click)="addOpenings()">Hinzufügen</button>
      </div>
    </div>
  </dialog>
}
